'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PortalConnector = function () {
  function PortalConnector() {
    var _this = this;

    (0, _classCallCheck3.default)(this, PortalConnector);

    this.nextId = 1;
    this.targetsByName = {};
    this.targetsByChildId = {};
    this.intentionToAdd = {};

    var methodNames = ['registerTarget', 'removeTarget', 'addChild', 'updateChild', 'removeChild'];

    methodNames.forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
  }

  (0, _createClass3.default)(PortalConnector, [{
    key: 'registerTarget',
    value: function registerTarget(name, portalTarget) {
      if (this.targetsByName[name]) {
        this.intentionToAdd[name] = portalTarget;
      } else {
        this.targetsByName[name] = {
          targetInstance: portalTarget,
          childrenById: {}
        };
      }
    }
  }, {
    key: 'removeTarget',
    value: function removeTarget(name, portalTarget) {
      if (this.targetsByName[name].targetInstance === portalTarget) {
        delete this.targetsByName[name];
      }
      if (this.intentionToAdd[name]) {
        this.registerTarget(name, this.intentionToAdd[name]);
        delete this.intentionToAdd[name];
      }
    }
  }, {
    key: 'addChild',
    value: function addChild(targetName, child) {
      var id = 'portalId' + this.nextId++;
      var target = this.targetsByName[targetName];

      // NOTE: we might want to refactor this... atm the portal relies on the
      // fact that the target has already been rendered, which is not really
      // necessary + limits the usage (you cannot use the Portal before the Target
      // in your app). We can easily store the child references even before rendering
      // the Target!
      (0, _invariant2.default)(target, 'No target with name ' + targetName + ' found.');

      this.targetsByChildId[id] = target;
      if (!child) {
        return id;
      }

      target.childrenById[id] = child;
      target.targetInstance.updateChildren((0, _values2.default)(target.childrenById));
      return id;
    }
  }, {
    key: 'updateChild',
    value: function updateChild(id, child) {
      var target = this.targetsByChildId[id];
      (0, _invariant2.default)(target, 'No target with id ' + id + ' found.');

      if (!child && !target.childrenById[id]) {
        return;
      }

      if (!child) {
        target.childrenById = _lodash2.default.omit(target.childrenById, id);
      } else {
        target.childrenById[id] = child;
      }
      target.targetInstance.updateChildren((0, _values2.default)(target.childrenById));
    }
  }, {
    key: 'removeChild',
    value: function removeChild(id) {
      var target = this.targetsByChildId[id];
      (0, _invariant2.default)(target, 'No target with id ' + id + ' found.');

      delete this.targetsByChildId[id];
      if (!target.childrenById[id]) {
        return;
      }

      target.childrenById = _lodash2.default.omit(target.childrenById, id);
      target.targetInstance.updateChildren((0, _values2.default)(target.childrenById));
    }
  }]);
  return PortalConnector;
}();

exports.default = PortalConnector;